const api_dev = "https://ben-parker-api.dev.belovedrobot.com/";
const api_beta = "https://ben-parker-api.beta.belovedrobot.com/";
const api_prod = "https://ben-parker-api.belovedrobot.com/";
const api_local = "http://localhost:3010/";
let apiURL;

if (process.env.REACT_APP_ENV === "production") {
  apiURL = api_prod;
} else if (process.env.REACT_APP_ENV === "development") {
  apiURL = api_dev;
} else if (process.env.REACT_APP_ENV === "beta") {
  apiURL = api_beta;
} else {
  apiURL = api_local;
}

const config = { apiURL };

export default config;
